import Vue from 'vue';
import { roles } from '@/types/Member';
Vue.filter('userRoleName', (code) => {
    return roles.find(p => p.seq === code)?.name || code;
});
